import {AbstractService, Expands, Filters} from "./abstract-service";
import {AxiosResponse} from "axios";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {User} from "../models/account/user";

export class UserService extends AbstractService<User> {

    constructor() {
        super("/api/account/");
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        return processedFilter;
    }

    async listGroups(): Promise<AxiosResponse<any>> {
        const path = `${this.path}group/`;
        return await trackPromise(Api.get(path));
    }

    async logged_user(): Promise<AxiosResponse<any>> {
        const path = `${this.path}/user/logged_user/`;
        return await trackPromise(Api.get(path));
    }

	async getRemoteUsers(): Promise<AxiosResponse<any>> {
		const path = `${this.path}/user/get_remote_users/`;
		return await trackPromise(Api.get(path));
	}

}
